import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Card, CardContent, Typography, Button, Box, IconButton, Grid , CircularProgress} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { QRCodeCanvas } from "qrcode.react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; 
import StepProgress from './StepProgress';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const MembershipIDCard = () => {
    
    const { user } = useAuth(); 
    const [formData, setFormData] = useState(null);
    const cardRef = useRef(null);
    const mandatoryFields = ["Family_Details", "Email", "Occupation", "Address", "Marital_Status",
        "ID_Proof_Type",  "ID_Proof_Number"
    ]; 
    const isDataIncomplete = formData && mandatoryFields
   .some(field => !formData[field] || formData[field] === "");

   const isPanCardNo = formData?.Pan_Card === "No";

   const isPanDetailsMissing = isPanCardNo && (!formData?.Pan_Number || formData?.Pan_Number === "");


    const isPaymentPending = formData?.Payment_Status
    != "Paid";
    const isGeneratePending = formData?.ID_Card
    === "Not_Generated";

    const [isLoading, setIsLoading] = useState(true); 
   
    const navigate = useNavigate();

    const storedUser = localStorage.getItem("first_name");


    const handleSubmit = async (e) => {
        setIsLoading(true);
        
        console.log("Generating ID Card...");
         // Ensure mobile number is available
        const mobileNumber = localStorage.getItem("mobile");



        const requestBody = {
            method: "PUT",
            mobile: mobileNumber,
            idCard: "Generated"
        };

        console.log("Request Body:", requestBody); // ✅ Logs the body before sending
        
        try {
            const response = await fetch(
                API_BASE_URL,
                {
                    method: "POST",
                    mode: "no-cors", // Prevents CORS issues
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                }
            );
            console.log("ID Card Generation Request Sent");
            console.log(response);
            fetchUserData();
            console.log("Generated", requestBody);
            console.log("Request Body:", requestBody);
            
        } catch (error) {
            console.error("Error Generating ID Card", error);
            alert("Failed to Generate ID Card");
            setIsLoading(false);
        }
    };
    

    const fetchUserData = () => {
        
        const mobile = localStorage.getItem("mobile");
        if (!mobile) {
            console.error("Mobile number not found in localStorage");
            return;
        }
        axios
            .get(`${API_BASE_URL}?action=myprofile&mobile=${mobile}`)
            .then((response) => {
                if (response.data.status === "success") {
                    setFormData(response.data.data);
                    console.log("Updated User Data:", response.data.data);
                    setIsLoading(false);
                } else {
                    console.error("API error:", response.data.message);
                }
            })
            .catch((error) => console.error("Error fetching data:", error));
    };

    useEffect(() => {
        handleSubmit();

       
    }, []);


    const handleDownload = async () => {
        const element = cardRef.current;
        const canvas = await html2canvas(element, { scale: 3 }); // Higher scale for better resolution
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
            orientation: "landscape",
            unit: "mm",
            format: [92, 60], // CR90 dimensions
        });
        pdf.addImage(imgData, "PNG", 0, 0, 92, 60);
        pdf.save("Membership_ID_Card.pdf");
    };
    
    console.log(formData);
  


    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            bgcolor="#f4f4f4"
            p={{ xs: 2, sm: 3 }}
            sx={{ backgroundColor: "#f8f9e9", py: 12, minHeight: "500px" }} // Increased py and added minHeight
            >


            
            <Typography variant="h5" sx={{ fontWeight: "500", color: "#2A289C", textAlign: "center", fontSize: "32px"  }} gutterBottom>
                Membership ID Card
            </Typography>

            <StepProgress />

            {isLoading  ? (
                <CircularProgress color="success" />
            ) : !formData ?(
                <CircularProgress color="success" />
            ): isDataIncomplete ? (
                    <Typography variant="body1" color="#7A7841" textAlign="center">
                    You're almost there {storedUser}! 
                    To obtain your official Membership ID Card, please complete your profile.<br />
                    This helps us verify your details and provide full access to membership benefits.{" "}
                    <Typography
                        component="span"
                        sx={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}
                        onClick={() => {
                            navigate("/profile");
                            window.scrollTo(0, 0);
                        }}
                    >
                        Click here
                    </Typography>{" "}
                    to navigate to your user profile.
                </Typography>

                    ): isPanDetailsMissing ? (
                        <Typography variant="body1" color="#7A7841" textAlign="center">
                        You're almost there {storedUser}! 
                        To obtain your official Membership ID Card, please provide your PAN Number in your profile.<br />
                        This helps us verify your details and provide full access to membership benefits.{" "}
                        <Typography
                            component="span"
                            sx={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}
                            onClick={() => {
                                navigate("/profile");
                                window.scrollTo(0, 0);
                            }}
                        >
                            Click here
                        </Typography>{" "}
                        to navigate to your user profile.
                    </Typography>
         
            ) : isPaymentPending ? (
                <Typography variant="body1" color="#7A7841" textAlign="center">
                 You're just one step away {storedUser}! To obtain your official Membership ID Card, 
                please make <br /> a one-time payment of ₹2000. This helps us verify your details and 
                provide full access to membership benefits. <br />
                <strong>Your current payment status is {formData.Payment_Status}</strong> <br />
                 {" "}<br />
                <Typography
                    component="span"
                    sx={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}
                    onClick={() => {
                        navigate("/paymentgateway");
                        window.scrollTo(0, 0);
                    }}
                >
                   Click here
                </Typography>{" "}
                to proceed with the payment.
                
            </Typography>
            ) : (
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    width={{ xs: "90%", sm: "80%", md: 600 }}
                    p={2}
                    border="2px solid #FAD707"
                    borderRadius={2}
                    bgcolor="#ffffff"
                    boxShadow={3}
                >
                    <IconButton onClick={handleDownload} color="black">
                        <DownloadIcon />
                        <Typography variant="body2" ml={1} color="black">
                            Download PDF
                        </Typography>
                    </IconButton>


                    <Card ref={cardRef} sx={{ width: "100%", p: 2, boxShadow: 3 }}>
                        <CardContent
                            sx={{
                                backgroundImage: "linear-gradient(to bottom, #FFD700, #FF4500)",
                                borderRadius: 2,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Grid item>
                                    <img src="/CWA_logo.png" alt="Logo" width={60} height={60} />
                                </Grid>
                                <Grid item>
                                    <Typography variant="h6" color="red" fontWeight="bold" textAlign="center">
                                        திருக்கடையூர் சேனைத்தலைவர் அறக்கட்டளை
                                    </Typography>
                                </Grid>
                            </Grid>


                            {/* White Box Section */}
                            <Box
                                sx={{
                                    width: "100%",
                                    maxWidth: 550,
                                    mt: 3,
                                    p: 2,
                                    background: "#f8f9e9",
                                    borderRadius: 2,
                                    display: "flex",
                                    flexDirection: { xs: "column", sm: "row" },
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: 2,
                                }}
                            >
                                <Box textAlign="left">
                                    <Typography variant="body1">
                                        <strong>NAME:</strong> {formData.First_Name} {formData.Last_Name}
                                    </Typography>
                                    <Typography variant="body1">
                                        <strong>MEMBER ID:</strong> {formData.Member_ID}
                                    </Typography>
                                    <Typography variant="body1">
                                        <strong>DISTRICT:</strong> {formData.District}
                                    </Typography>
                                    <Typography variant="body1">
                                        <strong>LOCATION:</strong> {formData.City}
                                    </Typography>
                                </Box>


                                <QRCodeCanvas
                                    value={`TKS Member ID: ${formData.Member_ID}\nName: ${formData.First_Name} ${formData.Last_Name}\nDistrict: ${formData.District}\nLocation: ${formData.City}\nMobile Number: ${formData.Mobile_Number}`}
                                    size={100} // Adjusted for responsiveness
                                    bgColor="transparent"
                                    fgColor="#000000"
                                    level="L"
                                    marginSize={-9}
                                    imageSettings={{
                                        src: "/CWA_logo.png",
                                        height: 20,
                                        width: 20,
                                        opacity: 1.1,
                                        excavate: true,
                                    }}
                                />
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            )}


            <Box mt={3}>
                <Button variant="contained" color="error" href="/">
                    Back to Homepage
                </Button>
            </Box>
        </Box>
    );
};


export default MembershipIDCard;



